import { CheckCircle2, Clock, AlertOctagon, Check, Circle } from "lucide-react";
import { dateBR, dateTimeBR } from "../lib/format";

const STATE = {
  no_prazo: ["No prazo", "text-emerald-700 bg-emerald-50 border-emerald-200", CheckCircle2],
  proximo: ["Próxima do prazo", "text-amber-800 bg-amber-50 border-amber-300", Clock],
  vencido: ["Prazo vencido", "text-rose-700 bg-rose-50 border-rose-200", AlertOctagon],
};

export const PromisePill = ({ s, testid }) => {
  if (!STATE[s]) return null;
  const [l, cls, Icon] = STATE[s];
  return <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}><Icon className="h-3 w-3" />{l}</span>;
};

export const daysLeftText = (n) => (n === undefined || n === null ? "" : n < 0 ? `${-n} dia(s) útil(eis) de atraso` : n === 0 ? "vence hoje" : `restam ${n} dia(s) útil(eis)`);

export function PromiseLine({ r, internal, testid = "promise-line" }) {
  if (!r.promised_due_date) return null;
  return (
    <div className="text-xs space-y-0.5" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-1.5"><span className="text-slate-500">Previsão de retorno:</span><b data-testid={`${testid}-date`}>até {dateBR(r.promised_due_date)}</b>{internal && <PromisePill s={r.promise_state} testid={`${testid}-state`} />}</div>
      <div className="text-slate-500">Prazo informado: {r.sla_business_days} dia(s) útil(eis){internal && ` · ${r.due_date_source === "manual" ? "definido manualmente" : "calculado"} · ${daysLeftText(r.business_days_left)}`}</div>
    </div>);
}

export function DemandTimeline({ sentAt, receivedAt, acceptedAt, promised, completedAt, testid = "demand-timeline" }) {
  const steps = [["Enviada", sentAt], ["Recebida pela DPdigi", receivedAt || acceptedAt], ["Em processamento", acceptedAt, promised && `Previsão de retorno: ${dateBR(promised)}`], ["Concluída", completedAt]];
  const cur = steps.findIndex((s) => !s[1]);
  return (
    <ol className="space-y-2" data-testid={testid}>{steps.map(([l, at, extra], i) => {
      const done = !!at; const now = i === cur;
      return (
        <li key={l} className="flex gap-2.5 text-sm" data-testid={`${testid}-${i}`} data-state={done ? "done" : now ? "current" : "todo"}>
          <span className={`mt-0.5 h-5 w-5 shrink-0 rounded-full flex items-center justify-center ${done ? "bg-emerald-500 text-white" : now ? "bg-indigo-600 text-white" : "bg-slate-200 text-slate-400"}`}>{done ? <Check className="h-3 w-3" /> : <Circle className="h-2 w-2 fill-current" />}</span>
          <div><div className={done ? "font-medium text-slate-900" : now ? "font-semibold text-indigo-700" : "text-slate-400"}>{l}{now && i === 1 ? " — aguardando conferência" : ""}</div>
            {at && <div className="text-xs text-slate-500">{dateTimeBR(at)}</div>}{extra && done && <div className="text-xs font-semibold text-slate-800">{extra}</div>}</div>
        </li>);
    })}</ol>);
}
